export const MATERIAL_COLOR = "#000000";
